import { Button, Form, notification, Popconfirm, Radio } from "antd";
import React, { useState } from "react";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { PiPlus } from "react-icons/pi";
import { addNewQuestion } from "../action";
import { CheckboxGroupProps } from "antd/es/checkbox";
import { type_options } from "./options";

type Props = {
  fetchData: () => void;
};

interface FormValues {
  question: {
    en: string;
    ar: string;
    fr: string;
  };
  type: "B" | "S";
}

const AddNewQuestion: React.FC<Props> = ({ fetchData }) => {
  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);
      const data = await addNewQuestion(formValues.question, formValues.type);

      if (data) {
        form.resetFields();
        fetchData();
        api.success({
          message: "Question added successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to add question",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form className="space-y-5" form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="question" label="Question" />
      <Form.Item name="type" label="Type" rules={[{ required: true }]}>
        <Radio.Group
          options={type_options}
          optionType="button"
          buttonStyle="solid"
        />
      </Form.Item>

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to add this question?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<PiPlus />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Adding Question..." : "Add Question"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default AddNewQuestion;
